import { BiTable } from 'react-icons/bi';
import {
  FiHome,
  FiUsers,
  FiBookOpen,
  FiMessageSquare,
  FiSettings,
  FiInfo,
  FiCreditCard,
} from 'react-icons/fi';

export const SchoolLinkItems = [
  {
    name: 'Escritorio',
    icon: FiHome,
    link: '/plataforma/school',
  },
  {
    name: 'Estudiantes',
    icon: FiUsers,
    link: '/plataforma/school/estudiantes',
  },
  {
    name: 'Académico',
    icon: FiBookOpen,
    subMenu: [
      {
        name: 'Clases en vivo',
        link: 'academico/clases-en-vivo',
      },
      {
        name: 'Actividades',
        link: 'academico/actividades',
      },
      {
        name: 'Preguntas',
        link: 'academico/preguntas',
      },
      {
        name: 'Mensajes',
        link: 'academico/mensajes',
      },
    ],
  },
  {
    name: 'Pizarrón',
    icon: FiMessageSquare,
    link: '/plataforma/school/pizarron',
  },
  {
    name: 'Cobros',
    icon: FiCreditCard,
    link: '/plataforma/school/cobros',
  },
  {
    name: 'Configuración',
    icon: FiSettings,
    link: '/plataforma/school/configuracion',
  },
  {
    name: 'Mi Institución',
    icon: FiInfo,
    link: '/plataforma/school/mi-institucion',
  },
];
